import { createRouter, createWebHistory } from 'vue-router';
import { ppsRoutes } from '@/modules/pps/routes';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    ...ppsRoutes,
    { path: '/settings', name: 'settings', component: () => import('@/shared/ui/Einstellungen.vue') },
    { path: '/:pathMatch(.*)*', name: 'not-found', component: () => import('@/shared/ui/NotFound.vue') },
  ],
});

// router.beforeEach((to, _from, next) => {
//   const publicPages = ['/login', '/logout'];
//   const authRequired = !publicPages.includes(to.path);

//   let loggedIn = false;

//   if (localStorage.getItem('wmsUser') || sessionStorage.getItem('wmsUser')) {
//     loggedIn = true;
//   }

//   if (authRequired && !loggedIn) {
//     return next('/login');
//   }

//   next();
// });

export default router;
